import React, { useState,useEffect,useContext,lazy,Suspense} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading,ClientForm,ControlAccessLogUser,constructionDocument,NoteInterne} from "@gull";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import ViewDetailDocument from './Comp/ViewDetailDocument'
import { Modal} from "react-bootstrap";

const LinkToDoc = lazy(() => import('../../../../@gull/components/Facturation/LinkToDoc'));
const SendEmailForm = lazy(() => import('../../../../@gull/components/form/SendEmailForm'));
const AlertDocument = lazy(() => import('./Comp/AlertDocument'));
const ChangeDateDoc = lazy(() => import('./Comp/ChangeDateDoc'));
const SaveTemplate = lazy(() => import('./Comp/SaveTemplate'));
const LimitDatePay = lazy(() => import('../CreateComp/EndComp/Comp/LimitDatePay'));
const ModePayDefault = lazy(() => import('../CreateComp/EndComp/Comp/ModePayDefault'));
const TextForm = lazy(() => import('../CreateComp/EndComp/Comp/TextForm'));
const PaymentAddForm = lazy(() => import('../CreateComp/EndComp/Comp/PaymentAddForm'));
const DuplicateDoc = lazy(() => import('./Comp/DuplicateDoc'));

const useLoad = (id) =>{
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [allInfos,setAllInfos] = useState({}) 
    const [companyInfos,setCompanyInfos] = useState({}) 
    const [clientDetail,setClientDetail]=useState({})
    const [itemsBilling,setItemsBilling]=useState([])
    const [datasPdf,setDatasPdf]=useState([])
    const [clientId,setClientId] = useState(false) 
    const [company,setCompany] = useState({}) 
    const [relance,setRelance] = useState(Date.now()) 
    const history = useHistory();
    const { authParam } = useContext(IsAuthContext);
    const [reloadPaiement,setReloadPaiement] = useState(Date.now()) 

    const [loadingPrevNext,setLoadingPrevNext] = useState(false)
    const [previousNextValid,setPreviousNextValid] = useState({
        previous:false,
        next:false
    })
    const [noReloadNeeded,setNoReloadNeeded] = useState(false)//Quand on change de page, on passe noReloadNeeded à true pour ne pas relancer le useEffect de construction au changement du param URL

    const [limitPayForm,setLimitPayForm]=useState({//pour pouvoir modifier les données dans la modal d'édit sans que les valeur du pdf changent 
        date:'',
        consequence:'',
    })

    const [modePayForm,setModePayForm]=useState({//pour pouvoir modifier les données dans la modal d'édit sans que les valeur du pdf changent 
        mode_paiement_default:'',
    })

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/company/"+authParam.company.id
            ).then((response) => {
                setCompany(response.data)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        })()
    }, [])

    const callBackConstruct = (response) => {
        if(response.status==1){
            // setItemsBilling(response.facture_article_list)
            if(response.type=='billingBuy' || response.type=='creditNoteBuy'){
                setClientDetail(response.fournisseur)
            }else{
                setClientDetail(response.client)
                setClientId(response.client_id)
            }

            // setAllInfos(response)
            let limitDateInit = {
                date:'',
                consequence:'',
            }
            if(response.date_limit!=null) limitDateInit.date = response.date_limit.split(' ')[0]
            if(response.infos_date_limit!=null) limitDateInit.consequence = response.infos_date_limit
            setLimitPayForm(limitDateInit)

            let modePayInit = {
                mode_paiement_default:'',
            }
            if(response.mode_paiement_default!=null) modePayInit.mode_paiement_default = response.mode_paiement_default
            setModePayForm(modePayInit)

            if(response.other_company_id!=null){
                setCompanyInfos(response.other_company)
            }else{
                setCompanyInfos(response.company)
            }
            setReloadPaiement(Date.now())
            setLoading(false)
        }else{
            swal.fire({
                title: t('notAvailable'),
                icon: 'error',
                timer: 1500, // Définir le temps en millisecondes après lequel la fenêtre se fermera
                showConfirmButton: false // Cacher le bouton de confirmation
            })
            setTimeout(() => {
                history.push('/invoice/dashboard');
            }, 500);
            setLoading(false)
        }
    };

    useEffect(function () {
        (async function() {
            if(!noReloadNeeded){
                setLoading(true)
                let data = {}
                constructionDocument(setLoading,id,callBackConstruct,t,data,setItemsBilling,setAllInfos,history,setDatasPdf)
            }else{
                setNoReloadNeeded(false)
            }
        })()
    }, [id,relance])

    useEffect(function () {
        (async function() {
            if(Object.keys(allInfos).length!=0){
                //Gestion du previous et next 
                let objPrevNext = {}

                //PREVIOUS
                if(allInfos.bar.split('-')[1] == "1"){
                    //Si le numéro à la suite du code barre est égal à 1, cela signifie qu'on est sur le 1er document, il n'y a donc pas de docuement précédent
                    objPrevNext.previous = false
                }else{
                    objPrevNext.previous = true
                }

                //NEXT
                //Pour le next, on appelle la get by numéro pour savoir si un document existe avec le numéro qui suit , si on rentre dans le valid false, on passe next à false
                let numeroDoc = allInfos.bar.split('-')[1]
                let paramMiddle = +numeroDoc + 1
                let paramCampany = (allInfos.other_company_id!=null) ? '/'+allInfos.other_company_id : ''
                const response = await axios.get(process.env.REACT_APP_API_URL+'api/facture/invoice/get_one_by_number/'+paramMiddle+'/'+allInfos.type+paramCampany
                ).then((response) => {
                    if(!response.data.valid){
                        objPrevNext.next = false
                    }
                    else{   
                        objPrevNext.next = true
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                })

                setPreviousNextValid(objPrevNext)
            }
        })()
    }, [allInfos])

    return [loading,setClientId,clientId,itemsBilling,clientDetail,setItemsBilling,setAllInfos,companyInfos,allInfos,limitPayForm,setLimitPayForm,company,callBackConstruct,setRelance,constructionDocument,previousNextValid,loadingPrevNext,setLoadingPrevNext,setNoReloadNeeded,modePayForm,setModePayForm,datasPdf,setDatasPdf,reloadPaiement]
}

const DetailDocument = ({id,setId,setTitleDocument,from,setBrownDocumentModal=false,setBtnDowloadPdfButtonModal=false}) =>{
    const t = useTranslate();
    const [loading,setClientId,clientId,itemsBilling,clientDetail,setItemsBilling,setAllInfos,companyInfos,allInfos,limitPayForm,setLimitPayForm,company,callBackConstruct,setRelance,constructionDocument,previousNextValid,loadingPrevNext,setLoadingPrevNext,setNoReloadNeeded,modePayForm,setModePayForm,datasPdf,setDatasPdf,reloadPaiement] = useLoad(id)
    const [columnShow,setColumnShow]=useState([])
    const [recapShow,setRecapShow]=useState([])
    const { authParam } = useContext(IsAuthContext);
    const [showEdit,setShowEdit]=useState(false) 
    const [validButton,setValidButton]=useState(false) 
    const [validIndividualButton,setValidIndividualButton]=useState({
        cancel:false,
        convertDevis:false,
        duplicate:false
    }) 
    const [errors,setErrors]=useState(false)  
    const history = useHistory();
    const [mustLogin,setMustLogin] = useState(false)
    const [pdf,setPdf] = useState(null)

    const moduleInvoice = authParam.modules.find(value=>value.name=='invoice')
    
    useEffect(function () {
        setColumnShow((allInfos.column_pdf!=null) ? allInfos.column_pdf.split(',') : [])
        setRecapShow((allInfos.recap_pdf!=null) ? allInfos.recap_pdf.split(',') : [])
    }, [allInfos])

    let devise = authParam.company.devise;
    let digit =  (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let descriptionToShow = ['name', 'capital', 'ridet', 'adresse', 'tel', 'email', 'adresse2', 'site', 'banqueNum']

    const [totalTgc,setTotalTgc]=useState(0) 

    useEffect(function () {
        if(allInfos.tgc){
            if (!Array.isArray(allInfos.tgc)) {
                let total = 0
                Object.entries(allInfos.tgc).map(([key,value])=>{
                    total += value
                })

                setTotalTgc(total)
            }
        }

    }, [allInfos])

    const closeModal = () =>{
        setShowEdit(false)
        setErrors(false)
    }

    const editPlusFacture = async (obj) =>{        
        let data = {}

        Object.entries(obj).map(([key,value])=>{
            if(key!='close') data[key]=value
        })
        constructionDocument(setValidButton,id,callBackConstruct,t,data,setItemsBilling,setAllInfos,false,setDatasPdf)

        if(obj.hasOwnProperty('close')){
            //Si close est passé dans obj, on ferme la modal 
            setTimeout(() => {
                closeModal()
            }, 1000);
        }
    }

    const cancelInvoiceApi = async () => {
        setValidIndividualButton({...validIndividualButton,cancel:true})
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/invoice/cancelled/"+id
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                if(response.data.data){ 
                    history.push('/invoice/details/'+response.data.data.id)
                }else{
                    setRelance(Date.now())
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setValidIndividualButton({...validIndividualButton,cancel:false})
    };

    const cancelInvoice =  () =>{
        //Dans le cas de l'annulation d'une facture, on vérifie si l'utilisateur à l'autorisation de créer des avoirs, car l'annulation d'une facture génère un avoir
        if(authParam.access.find(access=>access.action=='createCreditNote')){
            setMustLogin(true)
        }else{
            setMustLogin(false)
            cancelInvoiceApi()
        }
    }

    const validateDeliveryNote = async () => {
        setValidIndividualButton({...validIndividualButton,cancel:true})
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/invoice/validate_delivery_note/"+id
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                setRelance(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setValidIndividualButton({...validIndividualButton,cancel:false})
    }

    const convertDeliveryNoteToInvoice = async () => {
        setValidIndividualButton({...validIndividualButton,convertDeliveryNoteToInvoice:true})
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/invoice/convert_delivery_note_to_invoice/"+id
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                if(response.data.valid){ 
                    history.push('/invoice/details/'+response.data.data.id)
                }else{
                    setRelance(Date.now())
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setValidIndividualButton({...validIndividualButton,cancel:false})
    }

    const convertQuotationToInvoice = async () =>{
        setValidIndividualButton({...validIndividualButton,convertDevis:true})
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/invoice/convert_devis/"+id
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");

            }else{  
                history.push('/invoice/document/create-add-items/'+response.data.data.id);
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidIndividualButton({...validIndividualButton,convertDevis:false})
    }

    const duplicateDocument = async (datas) =>{
        setValidIndividualButton({...validIndividualButton,duplicate:true})
        setValidButton(true)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/facture/invoice/duplicate_facture/"+id,datas
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");

            }else{  
                history.push('/invoice/document/create-add-items/'+response.data.data.id);
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidIndividualButton({...validIndividualButton,duplicate:false})
        setValidButton(false)
    }

    let modalTitle = 
        (showEdit == 'sendEmail') ? t('sendDocEmail') : 
        (showEdit == 'payment' && allInfos.type=='billing') ? t('payment') : 
        (showEdit == 'payment' && allInfos.type=='purchaseOrderB2b') ? t('depositLabel') : 
        (showEdit == 'payment' && (allInfos.type=='quotation')) ? t('depositLabel') : 
        (showEdit == 'payment' && (allInfos.type=='billingDeposit')) ? t('btnModifier')+' '+t('depositLabel').toLowerCase() : 
        (showEdit == 'creationDate') ? t('createdAt') : 
        (showEdit == 'limitpay' && allInfos.type=='billing') ? t('limitDatePay') : 
        (showEdit == 'limitpay' && allInfos.type=='quotation') ? t('limitDateValidity') : 
        (showEdit == 'saveTemplate') ? t('saveDocTemplate') : 
        (showEdit == 'topText' || showEdit == 'bottomText') ? t(showEdit) : 
        (showEdit == 'alertDoc') ? t('createReminderFromDoc') : 
        (showEdit == 'modePayDefault') ? t('modePay') : 
        (showEdit == 'note') ? t('noteInterne') : 
        (showEdit == 'duplicate') ? t('duplicate') : ''

    const accessCallback = () => {
        setMustLogin(false)
        cancelInvoiceApi()
    };

    //pour assombrir la modal du document
    useEffect(function (){
        if(setBrownDocumentModal){
            if(showEdit || mustLogin) setBrownDocumentModal(true)
            else setBrownDocumentModal(false)
        }
    },[showEdit,mustLogin])
    //end

    const callbackFolderLink = (folder) => {
        editPlusFacture({dossier_b2b_id:folder.id, close:''})
    };

    if(loading || Object.keys(allInfos).length==0){
        return(
            <Loading></Loading>
        )
    }

    return (
        <div>
            <Modal show={mustLogin} onHide={()=>setMustLogin(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('cancellationOfInvoice')+allInfos.bar}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ControlAccessLogUser module='invoice' accessName='createCreditNote' accessCallback={accessCallback} />
                </Modal.Body>
            </Modal>
            <Modal size="xl" show={showEdit=='client'} onHide={()=>closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('customer')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='mt-3'>
                        <ClientForm 
                            setClientId={setClientId}
                            clientid={clientId}
                            closeModal={closeModal}
                            module='facturationEdit'
                            editPlusFacture={editPlusFacture}
                            b2b={true}
                            moduleApp='B2B'
                        />  
                    </div>  
                </Modal.Body>
            </Modal>
            <Modal size="lg" show={showEdit && showEdit!='client'} onHide={()=>closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        (showEdit == 'sendEmail') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <SendEmailForm closeModal={closeModal} document={allInfos} setAllInfos={setAllInfos} pdf={pdf} moduleInvoice={moduleInvoice}/>
                            </Suspense> :
                        (showEdit == 'payment') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <PaymentAddForm  errors={errors} setErrors={setErrors} validButton={validButton} setValidButton={setValidButton} edit={true} editPlusFacture={editPlusFacture} allInfos={allInfos} company={company} reloadPaiement={reloadPaiement}/>
                            </Suspense> :
                        (showEdit == 'folder') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <LinkToDoc size='100%' company={company} callbackFolderLink={callbackFolderLink} clientFacture={(allInfos.type!='billingBuy' && allInfos.type!='creditNoteBuy') ? clientDetail : false} folderFacture={allInfos.dossier_b2b} allInfos={allInfos} />
                            </Suspense> :
                        (showEdit == 'creationDate') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <ChangeDateDoc editPlusFacture={editPlusFacture} allInfos={allInfos} validButton={validButton} errors={errors} setErrors={setErrors}/>
                            </Suspense> :
                        (showEdit == 'limitpay') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <LimitDatePay limitPayForm={limitPayForm} setLimitPayForm={setLimitPayForm} validButton={validButton} errors={errors} setErrors={setErrors} edit={true} editPlusFacture={editPlusFacture} documentType={allInfos.type} from='detailDocument'/> 
                            </Suspense> :
                        (showEdit == 'modePayDefault') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <ModePayDefault modePayForm={modePayForm} setModePayForm={setModePayForm} validButton={validButton} errors={errors} setErrors={setErrors} edit={true} editPlusFacture={editPlusFacture} documentType={allInfos.type} from='detailDocument'/> 
                            </Suspense> :
                        (showEdit == 'topText' || showEdit == 'bottomText') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <TextForm validButton={validButton} edit={true} editPlusFacture={editPlusFacture} isFor={showEdit} errors={errors} setErrors={setErrors} allInfos={allInfos} from='detailDocument'/> 
                            </Suspense> :
                        (showEdit == 'saveTemplate') ?
                            <Suspense fallback={<Loading></Loading>} >
                                <SaveTemplate  id={id} setValidButton={setValidButton} validButton={validButton} errors={errors} setErrors={setErrors}/>
                            </Suspense> :
                        (showEdit == 'note') ?
                            <Suspense fallback={<Loading></Loading>} >
                                <NoteInterne  id={id} editPlusFacture={editPlusFacture} validButton={validButton} allInfos={allInfos} from='detailDocument'/>
                            </Suspense> :
                        (showEdit == 'alertDoc') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <AlertDocument  id={id} setValidButton={setValidButton} validButton={validButton} errors={errors} setErrors={setErrors} allInfos={allInfos} setAllInfos={setAllInfos} from='detailDoc' editPlusFacture={editPlusFacture} /> 
                            </Suspense> :
                        (showEdit == 'duplicate') ? 
                            <Suspense fallback={<Loading></Loading>} >
                                <DuplicateDoc duplicateDocument={duplicateDocument} allInfos={allInfos} validButton={validButton} errors={errors} setErrors={setErrors}/>
                            </Suspense> :
                        false
                    }
                </Modal.Body>
            </Modal>
            {Object.keys(allInfos).length!=0 &&
                <ViewDetailDocument 
                    allInfos={allInfos}
                    clientDetail={clientDetail}
                    showEdit={showEdit}
                    setShowEdit={setShowEdit}
                    cancelInvoice={cancelInvoice}
                    validIndividualButton={validIndividualButton}
                    convertQuotationToInvoice={convertQuotationToInvoice}
                    validateDeliveryNote={validateDeliveryNote}
                    convertDeliveryNoteToInvoice={convertDeliveryNoteToInvoice}
                    id={id}
                    setId={setId}
                    setTitleDocument={setTitleDocument}
                    itemsBilling={itemsBilling}
                    datasPdf={datasPdf}
                    setItemsBilling={setItemsBilling}
                    setAllInfos={setAllInfos}
                    constructionDocument={constructionDocument}
                    devise={devise}
                    digit={digit}
                    companyInfos={companyInfos}
                    company={company}
                    setRelance={setRelance}
                    columnShow={columnShow}
                    recapShow={recapShow}
                    setColumnShow={setColumnShow}
                    setRecapShow={setRecapShow}
                    duplicateDocument={duplicateDocument}
                    previousNextValid={previousNextValid}
                    loadingPrevNext={loadingPrevNext}
                    setLoadingPrevNext={setLoadingPrevNext}
                    callBackConstruct={callBackConstruct}
                    setNoReloadNeeded={setNoReloadNeeded}
                    setDatasPdf={setDatasPdf}
                    from={from}
                    setBrownDocumentModal={setBrownDocumentModal}
                    setBtnDowloadPdfButtonModal={setBtnDowloadPdfButtonModal}
                    setPdf={setPdf}
                />
            }
        </div>
    )
};

export default DetailDocument;
